import React, { useEffect, useState } from "react";
import { Users, Coins, Copy, Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nContext";
import { useToast } from "@/hooks/use-toast";
import api from "@/lib/api";
import { copyToClipboard } from "@/lib/utils";
import { DASHBOARD } from "@/constants/testIds";

export default function ReferralTab() {
  const { t } = useI18n();
  const { toast } = useToast();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/referral/me").then(({ data }) => setData(data));
  }, []);

  if (!data) return null;

  const referralLink = `${window.location.origin}/register?ref=${data.referral_code}`;

  const copyLink = async () => {
    const copied = await copyToClipboard(referralLink);
    toast(copied ? { title: t("referral.linkCopied") } : { title: t("referral.yourLink"), description: referralLink });
  };

  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-primary/30 bg-primary/5 p-6">
        <div className="flex items-center gap-2">
          <Gift className="h-5 w-5 text-primary" />
          <h3 className="font-heading text-lg font-medium">{t("referral.title")}</h3>
        </div>
        <p className="mt-2 text-sm text-muted-foreground">{t("referral.subtitle")}</p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Users className="h-4 w-4" />
            <span className="text-xs font-medium uppercase">{t("referral.friendsInvited")}</span>
          </div>
          <p className="mt-2 font-heading text-2xl font-semibold">{data.referred_count}</p>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Coins className="h-4 w-4" />
            <span className="text-xs font-medium uppercase">{t("referral.tokensEarned")}</span>
          </div>
          <p className="mt-2 font-heading text-2xl font-semibold">{data.tokens_earned}</p>
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-card p-5">
        <p className="text-sm font-medium text-muted-foreground">{t("referral.yourLink")}</p>
        <div className="mt-2 flex items-center gap-2">
          <code className="flex-1 truncate rounded-xl bg-muted px-3 py-2 text-xs">{referralLink}</code>
          <Button size="sm" className="rounded-full" data-testid={DASHBOARD.referralCopyBtn} onClick={copyLink}>
            <Copy className="mr-1.5 h-3.5 w-3.5" />
            {t("referral.copyLink")}
          </Button>
        </div>
        <p className="mt-4 text-xs text-muted-foreground">{t("referral.howItWorks")}</p>
      </div>
    </div>
  );
}
